import { StackedColumnComponent } from '../charts/stacked-column-chart-component'
import { TRANSFORM_SENTIMENTS_TO_WORDS } from '../commons/constants'

export class AFCompareSentiment extends StackedColumnComponent {
 static config = {
  selector: 'afCompareSentiment',
  controller: AFCompareSentiment,
  bindings: StackedColumnComponent.config.bindings,
  template: StackedColumnComponent.config.template,
 }

 setProperties() {
  this.seriesColors = this.colorUtils.setColorPalette(this.buildChartData(this.vizData.data))
  this.transformationProfiles = [{
    key: 'key',
    type: TRANSFORM_SENTIMENTS_TO_WORDS,
}]
 }

 updateData(data) {
  this.visualizationDataArray = this.isObjEmpty(data)
   ? []
   : this.sortCompareLoopDeep(this.buildChartData(data), 'key', this.visualizationMetaData)
 }
}
